
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16 2a14 14 0 1 0 14 14A14.016 14.016 0 0 0 16 2Zm0 26.5a12.5 12.5 0 1 1 0-25 12.5 12.5 0 0 1 0 25Zm0-19a6.5 6.5 0 1 0 6.5 6.5A6.507 6.507 0 0 0 16 9.5ZM16 21a4.999 4.999 0 1 1 0-9.998A4.999 4.999 0 0 1 16 21Zm-2.222-8.326a4 4 0 1 1 4.444 6.653 4 4 0 0 1-4.444-6.653Zm.833 5.405a2.5 2.5 0 1 0 2.778-4.157 2.5 2.5 0 0 0-2.778 4.157ZM16.75 27a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm-2.25-3.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM19.75 25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM24 20.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM26.75 19a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm-1.25 3.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm-.75-7.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM19.5 5.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM24.25 11a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM21.5 8.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM8.75 21.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm1.75 2.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM7.5 17a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM16 7.5a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM8.25 10a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM13 5.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM5.75 14a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM6 19.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z"}})])
          )
        }
      }
    